import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnergyStarItem, EnergyStarItemsResponse } from 'brain-data/model/energy-star-item.model';
import { environment } from '../../../../environments/environment';

export const ENERGY_STAR_ITEMS_URL = `${environment.apiBaseUrl}/facilities/energyStarItems`;

@Injectable({
  providedIn: 'root',
})
export class EnergyStarItemService {
  constructor(private http: HttpClient) {}

  getEnergyStarItems(facilityGroupId: number, year: number): Observable<EnergyStarItem[]> {
    return this.http
      .get<EnergyStarItemsResponse>(`${ENERGY_STAR_ITEMS_URL}?facilityGroupId=${facilityGroupId}&year=${year}`)
      .pipe(map(response => response.data));
  }

  getEnergyStarItemsHistory(facilityGroupId: number): Observable<EnergyStarItem[]> {
    return this.http.get<EnergyStarItemsResponse>(`${ENERGY_STAR_ITEMS_URL}?facilityGroupId=${facilityGroupId}`).pipe(map(response => response.data));
  }

  updateEnergyStarStatus(facilityId: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/facilities/${facilityId}/energyStarItem/status/update`, {});
  }
}
